import ProductCreateForm from './product-create-form'

export default ProductCreateForm;